import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectScheduleState = (state: AppState) =>
  state.schedule;


export const selectSchedules = createSelector(
    selectScheduleState,
  (state) => state.schedules
);
export const selectScheduleAdding = createSelector(
    selectScheduleState,
  (state) => state.scheduleAdding
);
export const selectScheduleAdded = createSelector(
    selectScheduleState,
  (state) => state.scheduleAdded
);
export const selectScheduleEditing = createSelector(
    selectScheduleState,
  (state) => state.scheduleEditing
);
export const selectScheduleEdited = createSelector(
    selectScheduleState,
  (state) => state.scheduleEdited
);
